// Env vars split into two tiers:
//   build-time: baked into bundle by CRA DefinePlugin (Dockerfile ARGs).
//   runtime: written to window._env_ by docker-entrypoint.sh at container start.
// In `npm start` both resolve via process.env from .env.
//
// DISABLE_AUTH is intentionally build-time only — it must never be flippable
// at container runtime. Production images are built without the flag, so the
// bundle always resolves DISABLE_AUTH=false.

/* ── Runtime vars (supplied via env-config.js at container start) ── */

interface RuntimeEnv {
  REACT_APP_REDIRECT_URI?: string
  REACT_APP_BACKEND_URL?: string
  REACT_APP_DATADOG_APPLICATION_ID?: string
  REACT_APP_DATADOG_RELEASE_TAG?: string
  REACT_APP_DATADOG_SERVICE_NAME?: string
  REACT_APP_DATADOG_TRACING_URLS?: string
  REACT_APP_BUILD_ENV?: string
  REACT_APP_VERSION?: string
}

declare global {
  interface Window {
    _env_: RuntimeEnv
  }
}

function getRuntimeEnv(key: keyof RuntimeEnv): string | undefined {
  return window._env_?.[key] || process.env[key]
}

export const env = {
  // Build-time (baked into bundle, not in env-config.js)
  AZURE_CLIENT_ID: process.env.REACT_APP_AZURE_CLIENT_ID ?? '',
  AZURE_ENTRA_CLIENT_ID: process.env.REACT_APP_AZURE_ENTRA_CLIENT_ID ?? '',
  AZURE_TENANT_ID: process.env.REACT_APP_AZURE_TENANT_ID ?? '',
  DATADOG_CLIENT_TOKEN: process.env.REACT_APP_DATADOG_CLIENT_TOKEN ?? '',

  // Runtime
  REDIRECT_URI: getRuntimeEnv('REACT_APP_REDIRECT_URI') ?? 'http://localhost:3000/',
  BACKEND_URL: getRuntimeEnv('REACT_APP_BACKEND_URL') ?? 'http://localhost:8000/',
  DATADOG_APPLICATION_ID: getRuntimeEnv('REACT_APP_DATADOG_APPLICATION_ID') ?? '',
  DATADOG_RELEASE_TAG: getRuntimeEnv('REACT_APP_DATADOG_RELEASE_TAG') ?? '',
  DATADOG_SERVICE_NAME: getRuntimeEnv('REACT_APP_DATADOG_SERVICE_NAME') ?? 'frontend',
  DATADOG_TRACING_URLS: getRuntimeEnv('REACT_APP_DATADOG_TRACING_URLS') ?? '',
  BUILD_ENV: getRuntimeEnv('REACT_APP_BUILD_ENV') ?? 'development',
  VERSION: getRuntimeEnv('REACT_APP_VERSION') ?? '1.0.0',
  DISABLE_AUTH: (process.env.REACT_APP_DISABLE_AUTH ?? 'false') === 'true',
}
